import { render, staticRenderFns } from "./ArticlesInstock.vue?vue&type=template&id=8e560852&scoped=true&"
import script from "./ArticlesInstock.vue?vue&type=script&lang=js&"
export * from "./ArticlesInstock.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesInstock.vue?vue&type=style&index=0&id=8e560852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e560852",
  null
  
)

export default component.exports